export const LOGGING_IN = 'Logging In';
